import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import T from "../../assets/TransferCase.png";

const TransferCase = () => {
  return (
    <>
      <SeoHead
        title="Transfer Case Repair in Temecula | Advanced Automotive Smog"
        description="Transfer case diagnostics, repair, and maintenance in Temecula for 4WD and AWD vehicles, addressing noises, leaks, and shifting issues."
        path="/services/transfer-case"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Transfer Case Repair & Service"
          path="/services/transfer-case"
          description="Transfer case diagnostics, repair, and maintenance in Temecula for 4WD and AWD vehicles."
          serviceType="Transfer case repair"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={T}
                alt="Transfer case repair and service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              4WD / AWD Drivetrain
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Transfer Case Repair &amp; Service
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Keep your 4WD or AWD vehicle ready for any road. We provide expert
              transfer case diagnostics, repair, and maintenance so you don&apos;t
              lose power where it matters most.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is a Transfer Case?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              The transfer case splits power from the transmission to the front
              and rear axles in 4WD and AWD vehicles. When it isn&apos;t working
              properly, you may feel binding, hear grinding, or have trouble
              engaging 4x4 modes.
              <br />
              <br />
              We diagnose noises, leaks, shifting issues, and internal wear, then
              repair or replace components using high-quality parts to restore
              smooth, confident drivability.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Fast, reliable transfer case diagnostics and repair
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                High-quality replacement parts for 4WD &amp; AWD systems
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Professional service and installation with warranty options
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Helps prevent driveline damage and loss of traction
              </li>
            </ul>

            {/* Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default TransferCase;

